(function () {
  function debounce(callback, delay) {
    let timer = null;
    return (...args) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => callback(...args), delay);
    };
  }

  window.RotaTheme?.register('cart-page', {
    init(section) {
      if (!window.RotaCartAPI) return null;
      let refreshController = null;
      const status = section.querySelector('[data-cart-status]');
      const errorBox = section.querySelector('[data-cart-error]');

      const setLoading = (loading) => {
        section.toggleAttribute('data-cart-loading', loading);
      };

      const showError = (message) => {
        if (!errorBox) return;
        errorBox.textContent = message || section.dataset.labelError;
        errorBox.hidden = false;
      };

      const clearError = () => {
        if (!errorBox) return;
        errorBox.textContent = '';
        errorBox.hidden = true;
      };

      const announce = (message) => {
        if (status) status.textContent = message;
      };

      const refresh = async (message) => {
        refreshController?.abort();
        refreshController = new AbortController();
        const [cart, sections] = await Promise.all([
          window.RotaCartAPI.getCart(),
          window.RotaCartAPI.getSections(['main-cart', 'cart-drawer'], refreshController.signal),
        ]);
        window.RotaCartAPI.updateCartCount(cart.item_count);
        const replaced = window.RotaCartAPI.replaceSectionContent(sections['main-cart'], '[data-cart-page]');
        window.RotaCartAPI.replaceSectionContent(sections['cart-drawer'], '[data-cart-drawer-content]');
        window.RotaCartAPI.announceUpdated(cart);
        if (!replaced) window.location.reload();
        announce(message || section.dataset.labelUpdated);
      };

      const changeQuantity = async (lineKey, quantity, message) => {
        clearError();
        setLoading(true);
        try {
          await window.RotaCartAPI.changeLine(lineKey, Math.max(0, quantity));
          await refresh(message);
        } catch (error) {
          showError(error.message);
        } finally {
          setLoading(false);
        }
      };

      const updateNote = debounce(async (value) => {
        clearError();
        setLoading(true);
        try {
          const cart = await window.RotaCartAPI.updateCart({ note: value });
          window.RotaCartAPI.announceUpdated(cart);
          announce(section.dataset.labelUpdated);
        } catch (error) {
          showError(error.message);
        } finally {
          setLoading(false);
        }
      }, 500);

      const handleClick = (event) => {
        const remove = event.target.closest('[data-cart-remove]');
        if (remove) {
          event.preventDefault();
          changeQuantity(remove.dataset.cartRemove, 0, section.dataset.labelRemoved);
          return;
        }

        const quantityButton = event.target.closest('[data-quantity-action]');
        if (!quantityButton) return;
        event.preventDefault();
        const wrapper = quantityButton.closest('[data-quantity-input]');
        const input = wrapper?.querySelector('[data-quantity-field]');
        const lineKey = wrapper?.dataset.lineKey;
        if (!input || !lineKey) return;
        const current = Number.parseInt(input.value, 10) || 1;
        const next = quantityButton.dataset.quantityAction === 'increase' ? current + 1 : Math.max(0, current - 1);
        changeQuantity(lineKey, next, section.dataset.labelUpdated);
      };

      const handleChange = (event) => {
        const quantityInput = event.target.closest('[data-quantity-field]');
        if (quantityInput) {
          const wrapper = quantityInput.closest('[data-quantity-input]');
          const lineKey = wrapper?.dataset.lineKey;
          if (!lineKey) return;
          changeQuantity(lineKey, Number.parseInt(quantityInput.value, 10) || 0, section.dataset.labelUpdated);
          return;
        }

        const note = event.target.closest('[data-cart-note]');
        if (note) updateNote(note.value);
      };

      const handleInput = (event) => {
        const note = event.target.closest('[data-cart-note]');
        if (note) updateNote(note.value);
      };

      section.addEventListener('click', handleClick);
      section.addEventListener('change', handleChange);
      section.addEventListener('input', handleInput);

      return () => {
        refreshController?.abort();
        section.removeEventListener('click', handleClick);
        section.removeEventListener('change', handleChange);
        section.removeEventListener('input', handleInput);
      };
    },
  });
})();
